module.exports = __webpack_public_path__ + "img/landing_background.0d788046.png";